/*
 * This is the main file js for Scott Neve
 * version 1.0
 */

$(function () {
  function initSlider() {
    var sliderSettings = {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
          },
        },
      ],
    };

    var slideEle = $(".slider-component");
    slideEle.each(function (index) {
      var slidesShow = parseInt($(this).attr("data-slideshow"));
      var slidesShowM = parseInt($(this).attr("data-slideshow-mobile"));
      var slideItems = $(this).find(".slider-component-item");
      if (slidesShow) {
        sliderSettings.slidesToShow = slidesShow;
        sliderSettings.slidesToScroll = slidesShow;
      }
      if(slidesShowM){
        sliderSettings.responsive[0].settings.slidesToShow = slidesShowM;
      }

      $(this).slick(sliderSettings);
    });
  }
  initSlider();

  $('.social-shares a').click(function(e){
    e.preventDefault();
    var urlActual = window.location.href;
    var urlShare = encodeURIComponent(urlActual),
        textShareT = $('meta[property="twitter:description"]').attr("content") ? $('meta[property="twitter:description"]').attr("content") : '',
        dataSocial = $(this).attr("data-social");
    function open_Window(url, name) {
        window.open(url, name, 'height=320, width=640,toobar=no, menubar=no, scrollbars=yes, resizable=yes, location=no, directories=no, status=no');
    } if (dataSocial === "facebook") {
        open_Window('https://www.facebook.com/sharer/sharer.php?u=' + urlShare, 'facebook_share');
    } else if (dataSocial === "twitter") {
        open_Window('https://twitter.com/intent/tweet?text=' + textShareT + " " + urlShare);
    } else if (dataSocial === "whatsapp") {
      open_Window('https://api.whatsapp.com/send?text=' + urlShare);
    }
  });

  $(".country-selector-close").click(function(e){
    e.preventDefault();
    $(this).parent().removeClass("open");
    if($('nav.navbar').scrollTop() < 1){
      $(this).parents('nav.navbar').removeClass('country');
    }
  });
  $('.country-selector .dropdown-toggle').click(function(){
    $(this).parents('nav.navbar').addClass('country');
  })
  // $('nav.navbar').scroll(function(){
  //   if($(this).scrollTop() > 1){
  //     $(this).addClass('country');
  //   }else{
  //     $(this).removeClass('country');
  //   }
  // });

  $('.product-info .btn-primary').not('.product.download .product-info .btn-primary').click(function(){
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  })

  $(".btn-up").click(function(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    // return false;
  });

  if(window.innerWidth > 768){
    $('.blocks-container .blocks-slider').slick('destroy');
    $('.gallery-images .gallery').not('.no-text').slick('destroy');
  }

  $('.short-text + .btn-read-more').click(function(e){
    e.preventDefault();
    $(this).parent().find("p.short-text").css('height', 'auto');
    $(this).hide();
  })

  var articles = $('.coupons-page .couponBlock').size();
  var loadItems = 3;

  $('.coupons-page .btn-load').click(function(e) {
      e.preventDefault();
      loadItems = (loadItems + loadItems <= articles) ? loadItems + loadItems : articles;
      $('.coupons-page .couponBlock:lt(' + loadItems + ')').removeClass('hidden-coupon');

      if (loadItems === articles) {
          $(this).hide();
      }
  })


  // TAGGING PLAN
  $(".hero-slider .slick-arrow").click(function(){
		$(this).attr("data-kl-event", "eventClick")
		$(this).attr("data-kl-category", "homepage")
    $(this).attr("data-kl-action", "click_slider")
    if($(this).hasClass('slick-prev')){
      $(this).attr("data-kl-label", "left")
    }else{
      $(this).attr("data-kl-label", "right")
    }
  });

  var inputsRegister = $(".form-subscribe input:not([type=hidden], .survey-questions input), .form-subscribe select");
  inputsRegister.change(function(){
      var inputName = $(this).attr('name');
      dataLayer.push({
          'eventCategory': 'subscription',
          'eventAction': 'formField Change',
          'eventLabel': inputName,
          'eventvalue':'',
          'event': 'FormChange'
      }); 
  });

  var inputsSurvey = $(".form-survey input:not([type=hidden]), .form-survey textarea");
  inputsSurvey.change(function(){
      var inputName = $(this).attr('name');
      if($(this).prop("tagName") == 'TEXTAREA'){
        inputName = 'Purchasefrequency';
      }
      dataLayer.push({
          'eventCategory': 'subscription',
          'eventAction': 'formField Change',
          'eventLabel': inputName,
          'eventvalue':'',
          'event': 'FormChange'
      }); 
  });
  
  var inputsContact = $(".form-contact input:not([type=hidden]), .form-contact textarea, .form-contact select");
  inputsContact.change(function(){
      var inputName = $(this).attr('name');
      if($(this).is('select')){
        inputName = $(this).find('option:selected').text()
      }
      dataLayer.push({
          'eventCategory': 'contact_us',
          'eventAction': 'formField Change',
          'eventLabel': inputName,
          'eventvalue':'',
          'event': 'FormChange'
      }); 
  });
  
  if(window.innerWidth > 768){
    $('.wrapper-cards .slider-component').slick('unslick')
  }

  // Search change
  $('#globalSearch').submit(function(e) {
    e.preventDefault();
    location.href=this.action+'#q='+encodeURIComponent(this.querySelector('input').value);
  });


});